import { createSlice } from "@reduxjs/toolkit";

export const initialEventNameState = {
    eventName: '',
    testId: '',
    showEmma: false
}

const askEmmaSlice = createSlice({
    initialState: initialEventNameState,
    name: 'askEmma',
    reducers: {
        setEventData(state, action) {
            const eventName = action.payload?.eventName || '';
            const testId = action.payload?.testId || '';

            return {
                ...state,
                eventName,
                testId
            }
        },
        setTestIdOfAskEmma(state, action) {
            const testId = action.payload?.testId || '';

            return {
                ...state,
                testId
            }
        },
        resetEventData(state) {
            return {
                ...state,
                eventName: '',
                testId: ''
            }
        },
        setShowEmma(state, action) {
            return {
                ...state,
                showEmma: action.payload
            }
        },
    }
})

export const {
    setEventData,
    resetEventData,
    setShowEmma,
    setTestIdOfAskEmma
} = askEmmaSlice.actions;
export default askEmmaSlice.reducer;
